

import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../../commonFunctions";
  
  const atmlogregister = {
    label: "ATM Log Register",
    pageLabel: "ATM Log Register",
    starting: true,
    url: "atmlogregister",
    pageType: "history",
    form: [
        {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Process Code",
            name: "",
            description: "Enter Process Code" 
          },
          {
            inputType: "select",
            default: "",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Cash Withdrawal",
                value: "Cash Withdrawal"
              },
              {
                label: "NFS Issue Withdrawal",
                value: "NFS Issue Withdrawal"
              },
              {
                label: "ATM Balance Inquiry",
                value: "ATM Balance Inquiry"
              },
              {
                label: "POS/BNA/CDM Balance Inquiry",
                value: "POS/BNA/CDM Balance Inquiry"
              },
              {
                label: "NFS Issuer Balance Inquiry",
                value: "NFS Issuer Balance Inquiry"
              },
              {
                label: "",
                value: ""
              },
              {
                label: "",
                value: ""
              },
              {
                label: "",
                value: ""
              },
              {
                label: "",
                value: ""
              },
              
             ],
            placeHolder: "",
            name: "ProcessCode",
            description: "Enter Process Code"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "EnterDate"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "From To Date",
            name: "",
            description: "EnterDate"
          },
          {
            inputType: "date",
            dateType: "ontype",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "From DAte",
            displayFormat: "DD/MM/YYYY",
            outputFormat: "YYYYMMDD",
            name: "FromDate",
            description: "Enter FromDate"
          },
          {
            inputType: "date",
            dateType: "ontype",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "From DAte",
            displayFormat: "DD/MM/YYYY",
            outputFormat: "YYYYMMDD",
            name: "ToDate",
            description: "Enter ToDate"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "EnterDate"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Reversal",
            name: "",
            description: "Enter Reversal" 
          },
          {
            inputType: "select",
            default: "",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [
             
              {
                label: "Passed Entries",
                value: "Passed Entries"
              },
              {
                label: "Only Reversal Entries",
                value: "Only Reversal Entries"
              },
              
             ],
            placeHolder: "",
            name: "Reversal",
            description: "Enter Reversal"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "EnterDate"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Terminal",
            name: "",
            description: "Enter Terminal"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Terminal",
            name: "Terminal",
            description: "Enter Terminal"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "EnterDate"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Card Number",
            name: "",
            description: "Enter Card Number"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Card Number",
            name: "CardNumber",
            description: "Enter Card Number"
          },

    ]
}
export default atmlogregister;